export const regularExpressions = {
  dateRegex: /\.\d+Z?$/,
  idSplitRegex: /[,\s]+/,
  separatorRegex: /[,\s]+/,
  billOfLading: /^[a-zA-Z0-9,\\\\/+_-]{1,35}$/
};
